import { EventEmitter, } from "@angular/core";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import { PlatformLocation } from '@angular/common';
var CasePracticeInfluenceListComponent = (function () {
    function CasePracticeInfluenceListComponent(commonService, apiService, platformLocation, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.platformLocation = platformLocation;
        this.route = route;
        this.router = router;
        this.onGoToNextStep = new EventEmitter();
        this.onSetPracticeIndex = new EventEmitter();
        //进入新能力考核标识
        this.version = 0;
        //学习 metaId
        this.learningPathMetaId = 0;
        this.isOpenClass = 0;
        this.isShowQuestionnaire = false;
        this.questionnaireInfo = null;
        this.approachTheme = {};
        this.currentIndex = 0;
        this.isShowApproach = false;
        this.alwaysShowSurvey = true;
        this.isCustomLock = false;
        /* 精彩瞬间 */
        this.showMoment = false;
        this.momentList = [];
        this.lock = false;
        this.isShowToast = false;
        this.isTencent = false; // 是否腾讯对接
    }
    Object.defineProperty(CasePracticeInfluenceListComponent.prototype, "showGoToSurveyBtn", {
        get: function () {
            return this.practiceList.every(function (item) {
                return item.status === 2;
            });
        },
        enumerable: true,
        configurable: true
    });
    CasePracticeInfluenceListComponent.prototype.ngOnInit = function () {
        var _this = this;
        // ---Stephen add 2025-03-07---
        // 添加是否腾讯对接的判断
        this.isTencent = this.commonService.checkAndSetModuleId();
        console.log(this.isTencent, '🐍🐍🐍🐍🐍🐍');
        // -------------------------------------------------------------------
        console.log(this.practiceList);
        var temp = true;
        var that = this;
        this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
        localStorage.setItem("moduleId", "3");
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        this.projectId = localStorage.getItem("projectId");
        var projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
        if (this.projectId && projectmsg) {
            projectmsg.map(function (item) {
                if (item.type == 4 && item.lockType == 1) {
                    _this.lock = item.lock;
                    _this.promptText = "\u80FD\u529B\u8003\u6838\u5C06\u4E8E" + item.promptTime + "\u5F00\u653E\u3002";
                }
            });
        }
        //loadconfig
        this.apiService
            .loadConfig("./assets/config/practiceList.json")
            .subscribe(function (result) {
            _this.practiceList.forEach(function (item, index) {
                if (result[item.title] != null) {
                    item["extends"] = result[item.title];
                }
            });
        });
        this.apiService
            .ajax({
            type: "get",
            url: "/api/concatenation/" + this.learningPathId,
            data: {
                learningPathId: this.learningPathId,
            },
        })
            .subscribe(function (comment) {
            comment.forEach(function (item, index) {
                if (item.title == "情景模拟") {
                    that.chuanjie = item.comment;
                }
            });
        });
        this.apiService
            .ajax({
            type: "get",
            url: "/sr/learningtour",
        })
            .subscribe(function (result) {
            _this.learningPathMetas = result.learning_path_metas;
            _this.learningTour =
                result.pre_survey_meta_ids.length > 0;
            _this.abilityConfig
                .getOnceinoByPracticeMetaId(_this.practiceMetaId)
                .subscribe(function (result) {
                _this.finishStatus = result == 1;
                for (var i = 0; i <= _this.practiceList.length - 1; i++) {
                    if (_this.practiceList[i].status != 2) {
                        temp = false;
                    }
                }
                _this.finished = temp;
                _this.getLearningPathMetaId();
                // this.getUserQuestionnaireInfo(this.learningPathMetaId).then(result=>{
                //   this.questionnaireInfo = result;
                //   this.isShowQuestionnaire = this.questionnaireInfo && (this.questionnaireInfo.length ===0 || (this.questionnaireInfo.length > 0 && this.questionnaireInfo.isShow !== 1)) && this.learningPathSubItems.filter(d=>d.type === 3)[0].progress ===100 && this.learningPathSubItems.filter(d=>d.type === 4)[0].progress!==100 ? true : false;
                // });
                setTimeout(function () {
                    if (_this.finished) {
                        //新能力考核 version == 1 时,有能力考核,出现考核按钮,完成按钮不出现
                        if (_this.version == 1) {
                            $("#surveyBtn").fadeIn(200);
                        }
                        else {
                            $("#nextWrap").show().animate({ bottom: 0 });
                        }
                    }
                }, 1000);
            });
        });
    };
    //获取进度
    CasePracticeInfluenceListComponent.prototype.getProgress = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
        }).toPromise();
    };
    //获取用户学习 metaid and version
    CasePracticeInfluenceListComponent.prototype.getLearningPathMetaId = function () {
        var that = this;
        this.learningPathMetas.forEach(function (item, i) {
            if (item.learningPathId == that.learningPathId) {
                if (that.type) {
                    $('#learningPathMetaIdContainer').val(item.id);
                }
                that.learningPathMetaId = item.id;
                that.getOrCreateLearningPath(String(that.learningPathMetaId)).then(function (result) {
                    that.learningPath = result;
                    that.commonService.setCustomLockDate(that.learningPath, Date());
                    that.learningPathSubItems = that.learningPath.subItems;
                }).then(function () {
                    return that.getUserQuestionnaireInfo(that.learningPathMetaId).then(function (result) {
                        return that.questionnaireInfo = result;
                    });
                }).then(function () {
                    return that.getProgress(that.learningPathMetaId).then(function (result) {
                        //向LMS传递进度
                        if (localStorage.getItem("source_env") === "LMS_SCORM") {
                            that.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', result[0].progressList[0].progress, "data");
                        }
                        return that.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'];
                    });
                }).then(function () {
                    that.approachTheme.colorSystem = 'dark';
                    that.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
                    that.approachTheme.currentIndex = that.currentIndex - 2;
                    that.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
                    that.approachTheme.btnTxt = '开启能力考核';
                    that.isShowQuestionnaire = that.questionnaireInfo && that.questionnaireInfo.length === 0 && that.learningPath.subItems.filter(function (d) { return d.type === 3; })[0].progress === 100 && that.learningPath.subItems.filter(function (d) { return d.type === 4; })[0].progress !== 100;
                }).then(function () {
                    //增加学习断点
                    that.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(that.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': that.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
                    that.isCustomLock = that.learningPathSubItems[3].isLock;
                    that.isShowApproach = true;
                });
                if (item.version) {
                    that.version = item.version;
                }
            }
        });
    };
    CasePracticeInfluenceListComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
    };
    CasePracticeInfluenceListComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            backgroundColor: "white",
        });
    }; //展示难忘瞬间gallary
    CasePracticeInfluenceListComponent.prototype.momentView = function (mlist, $event) {
        this.showMoment = true;
        this.momentList = mlist;
        $event.stopPropagation();
    };
    //关闭难忘瞬间gallary
    CasePracticeInfluenceListComponent.prototype.momentExit = function () {
        this.showMoment = false;
    };
    CasePracticeInfluenceListComponent.prototype.goToNextStep = function (i) {
        var _this = this;
        // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(i+1)}).then();
        this.onSetPracticeIndex.emit(i);
        // 如果是访客点击永远从头开始情景模拟
        if (this.userType) {
            this.onGoToNextStep.emit(1);
        }
        else {
            //正式用户流程
            //区分专业版
            var isProfessional = this.learningPathMetaId == 607;
            if (!isProfessional) {
                if (this.practiceList[i].status == 2) {
                    var link = [
                        "case-practice-report-new",
                        this.practiceId,
                        this.practiceList[i].id,
                        this.learningPathId,
                    ];
                    if (this.practiceMetaId == 10) {
                        link = [
                            "case-practice-report-new-2",
                            this.practiceId,
                            this.practiceList[i].id,
                            this.learningPathId,
                        ];
                    }
                    if (this.type) {
                        this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        this.router.navigate(link);
                    }
                }
                else if (this.practiceMetaId == 10) {
                    var link = [
                        "case-practice-hotel",
                        this.practiceId,
                        this.practiceList[i].id,
                        this.learningPathId,
                    ];
                    if (this.type) {
                        this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        this.router.navigate(link);
                    }
                }
                else if (this.practiceMetaId == 9 &&
                    this.practiceList[i].title == "供应商，真让人头大") {
                    var link = [
                        "case-practice-influence-supplier",
                        this.learningPathId,
                        this.practiceId,
                        this.practiceList[i].id,
                    ];
                    if (this.type) {
                        this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        this.router.navigate(link);
                    }
                }
                else {
                    this.apiService
                        .ajax({
                        type: "get",
                        url: "/api/pnoStorePoint/" + this.practiceList[i].id,
                    })
                        .subscribe(function (result) {
                        if (result.status == 0 || result.status == 5) {
                            _this.onGoToNextStep.emit(1);
                        }
                        else if (result.status == 10) {
                            var link = [
                                "case-practice-influence-main",
                                _this.learningPathId,
                                _this.practiceId,
                                _this.practiceList[i].id,
                            ];
                            if (_this.type) {
                                _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                            }
                            else {
                                _this.router.navigate(link);
                            }
                            if (_this.practiceList[0].status !== 2) {
                                var exerciseMetaId = $('#exerciseMetaId').val();
                                _this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 1, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                                    console.log(result);
                                });
                                console.log(exerciseMetaId);
                                _this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
                            }
                        }
                    });
                }
            }
            else {
                //专业版
                //第一个情景模拟
                if (this.practiceList[i].exerciseMetaId === 60701) {
                    var link = [
                        "case-practice-influence-pro-main",
                        this.learningPathId,
                        this.practiceId,
                        this.practiceList[i].id
                    ];
                    if (this.practiceList[i].status == 2) {
                        link = [
                            "case-practice-report-new",
                            this.practiceId,
                            this.practiceList[i].id,
                            this.learningPathId,
                        ];
                    }
                    if (this.type) {
                        this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        this.router.navigate(link);
                    }
                }
                //第二个情景模拟
                if (this.practiceList[i].exerciseMetaId === 60702) {
                    var link = [
                        "case-practice-influence-supplier",
                        this.learningPathId,
                        this.practiceId,
                        this.practiceList[i].id,
                        "607"
                    ];
                    if (this.practiceList[i].status == 2) {
                        link = [
                            "case-practice-report-new",
                            this.practiceId,
                            this.practiceList[i].id,
                            this.learningPathId,
                        ];
                    }
                    if (this.type) {
                        this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        this.router.navigate(link);
                    }
                }
                //第三个情景模拟
                if (this.practiceList[i].exerciseMetaId === 60703) {
                    var link = [
                        "case-practice-influence-supplier",
                        this.learningPathId,
                        this.practiceId,
                        this.practiceList[i].id,
                        "607"
                    ];
                    if (this.practiceList[i].status == 2) {
                        link = [
                            "case-practice-report-new",
                            this.practiceId,
                            this.practiceList[i].id,
                            this.learningPathId,
                        ];
                    }
                    if (this.type) {
                        this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        this.router.navigate(link);
                    }
                }
            }
        }
    };
    CasePracticeInfluenceListComponent.prototype.goToPostSurvey = function () {
        if (this.type === 'huatek') {
            this.commonService.sendPostMessage(1, 'goPostSurvey');
            return;
        }
        else {
            if (this.lock) {
                this.showToast();
                return;
            }
            this.apiService
                .ajax({
                type: "GET",
                url: "/sr/exposeoutapi/setAbilitySession/" +
                    this.learningPathMetaId +
                    "/4",
            })
                .subscribe(function (result) { });
            var link = void 0;
            link = ["ability-survey", this.learningPathMetaId, 2];
            // if (this.practiceMetaId == 10) {
            //   link = ["survey", this.learningPathId, 13, 1];
            // } else {
            //   link = ["survey", this.learningPathId, 15, 1];
            // }
            // //新能力考核
            // if (this.version == 1) {
            //   link = ["ability-survey", this.learningPathMetaId, 2];
            // }
            this.commonService.learningPortEventLogByCandy({ 'learningPathMetaId': this.learningPathMetaId, 'module': '情景模拟', 'btnName': this.approachTheme.btnTxt, 'userId': localStorage.getItem("userId") }).then();
            this.router.navigate(link);
        }
    };
    CasePracticeInfluenceListComponent.prototype.showToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    CasePracticeInfluenceListComponent.prototype.finish = function () {
        if (this.finishStatus) {
            return;
        }
        else {
            this.abilityConfig
                .setOnceinoByPracticeMetaId(this.practiceMetaId)
                .subscribe();
            var link = ["learning-map"];
            this.router.navigate(link);
        }
    };
    CasePracticeInfluenceListComponent.prototype.close = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
        })
            .subscribe(function (result) {
            // 只在learningTour里出现，当完成能力是退出进入map
            if ((_this.finishStatus || !_this.finished) && _this.learningTour) {
                var link = ["learning-map", 3];
                _this.router.navigate(link);
            }
            else if (!_this.finishStatus && _this.finished && _this.learningTour) {
                _this.abilityConfig
                    .setOnceinoByPracticeMetaId(_this.practiceMetaId)
                    .subscribe(function (result) {
                    var link = ["learning-map", 3];
                    _this.router.navigate(link);
                }, function (error) {
                    var link = ["error"];
                    _this.router.navigate(link);
                });
            }
            else {
                var link = ["learning-path", result.data];
                _this.router.navigate(link);
            }
        });
    };
    CasePracticeInfluenceListComponent.prototype.closeQuestionnaire = function () {
        this.isShowQuestionnaire = false;
    };
    //查询用户相应能力满意度
    CasePracticeInfluenceListComponent.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        }).toPromise();
    };
    return CasePracticeInfluenceListComponent;
}());
export { CasePracticeInfluenceListComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-list/case-practice-influence-list.component.ts.pre-build-optimizer.js